<ndt-tile-view
   [canRefresh]="true"
   [callState]="tile?.callState"
   [isEditing]="isEditing"
   [isFullscreen]="isFullscreen"
   [tileConfig]="tileConfig"
   [showHeader]="showHeader"
   [overrideRefreshTile]="false"
   (configureParameters)="onConfigureParameters()"
   ndtTileContainer
   (refreshTile)="onRefreshTile()"
>
   <p tileheadername>{{ tileConfig.dashboardTileLayoutConfiguration.name }}</p>

   <div tileInfo [ngSwitch]="viewMode">
      <div class="medium">
         <ndt-paged-table-wrapper [dataSource]="queueMembersData" [rowHeight]="rowHeight">
            <ng-template #pagedTable let-dataSource="dataSource">
               <table id="queue-members-table" lcs-table [dataSource]="dataSource">
                  <tr lcs-header-row *lcsHeaderRowDef="columns"></tr>
                  <tr lcs-row *lcsRowDef="let row; columns: columns"></tr>

                  <ng-container lcsColumnDef="agentName">
                     <th lcs-header-cell *lcsHeaderCellDef id="agentName-column-header">
                        Agent <mat-icon class="mat-icon-sort">{{ getSort('agentName') }}</mat-icon>
                     </th>
                     <td lcs-cell *lcsCellDef="let member" lang="en">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.agentName }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="callCount">
                     <th lcs-header-cell *lcsHeaderCellDef id="callCount-column-header" class="numeric">
                        Call Count <mat-icon class="mat-icon-sort">{{ getSort('callCount') }}</mat-icon>
                     </th>
                     <td lcs-cell class="numeric" *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.callCount }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="outboundCallCount">
                     <th lcs-header-cell *lcsHeaderCellDef id="outboundCallCount-column-header" class="numeric">
                        Outbound <mat-icon class="mat-icon-sort">{{ getSort('outboundCallCount') }}</mat-icon>
                     </th>
                     <td lcs-cell class="numeric" *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.outboundCallCount }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="overallTalkTime">
                     <th lcs-header-cell *lcsHeaderCellDef id="overallTalkTime-column-header" class="numeric">
                        Talk Time <mat-icon class="mat-icon-sort">{{ getSort('overallTalkTime') }}</mat-icon>
                     </th>
                     <td lcs-cell class="numeric" *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.overallTalkTime | formatMinutes }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="avgCallTime">
                     <th lcs-header-cell *lcsHeaderCellDef id="avgCallTime-column-header" class="numeric">
                        Avg Call Time <mat-icon class="mat-icon-sort">{{ getSort('avgCallTime') }}</mat-icon>
                     </th>
                     <td lcs-cell class="numeric" *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.avgCallTime | formatMinutes }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="callsPerHour">
                     <th lcs-header-cell *lcsHeaderCellDef id="callsPerHour-column-header" class="numeric">
                        Calls/Hour <mat-icon class="mat-icon-sort">{{ getSort('callsPerHour') }}</mat-icon>
                     </th>
                     <td lcs-cell class="numeric" *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.callsPerHour }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="currentTime">
                     <th lcs-header-cell *lcsHeaderCellDef id="currentTime-column-header" class="numeric">
                        Current Time <mat-icon class="mat-icon-sort">{{ getSort('currentTime') }}</mat-icon>
                     </th>
                     <td lcs-cell class="numeric" *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.currentTime != 0 ? (member.currentTime ?? 0 | formatMinutes) : '' }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="timeSinceLastCall">
                     <th lcs-header-cell *lcsHeaderCellDef id="timeSinceLastCall-column-header" class="numeric">
                        Time Since <mat-icon class="mat-icon-sort">{{ getSort('timeSinceLastCall') }}</mat-icon>
                     </th>
                     <td lcs-cell class="numeric" *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{
                              member.timeSinceLastCall != 0 && member.currentTime == 0
                                 ? (member.timeSinceLastCall ?? 0 | formatMinutes)
                                 : ''
                           }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="availability">
                     <th lcs-header-cell *lcsHeaderCellDef id="availability-column-header">
                        Status <mat-icon class="mat-icon-sort">{{ getSort('availability') }}</mat-icon>
                     </th>
                     <td lcs-cell *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.availability != 0 ? (member.availability | addSpaces) : 'Offline' }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="queues">
                     <th lcs-header-cell *lcsHeaderCellDef id="queues-column-header">
                        Queues <mat-icon class="mat-icon-sort">{{ getSort('queues') }}</mat-icon>
                     </th>
                     <td lcs-cell *lcsCellDef="let member">
                        <a [routerLink]="getRouterLink(member.agentExtensionId)">
                           {{ member.queues }}
                        </a>
                     </td>
                  </ng-container>
               </table>
            </ng-template>
         </ndt-paged-table-wrapper>
      </div>
   </div>

   <ndt-tile-parameters
      [tileConfig]="tileConfig"
      [formService]="formService"
      *ndtTileParametersDef
      tileParametersList
   ></ndt-tile-parameters>
</ndt-tile-view>
